import React from 'react';
import Main from '../../components/layout/Main';
import AdminPanelMainContent from './AdminPanelMainContent';
import {
  ChatAltIcon,
  HashtagIcon,
  UserIcon,
  ChartBarIcon,
  ArrowNarrowRightIcon,
  StarIcon,
  OfficeBuildingIcon,
  CloudIcon,
  FastForwardIcon,
  ClipboardListIcon,
  LockClosedIcon,
  DocumentTextIcon,
} from '@heroicons/react/outline';
import { Sidebar, TabGroup } from './Sidebar';
import { useParams } from 'react-router-dom';

const tabItems: Array<TabGroup> = [
  {
    label: 'Algemeen',
    tabs: [
      {
        label: 'Gebruikers',
        href: '/admin/users',
        id: 'users',
        disabled: false,
        Icon: UserIcon,
      },
      {
        label: 'Statistieken',
        href: '/admin/statistics',
        id: 'statistics',
        disabled: false,
        Icon: ChartBarIcon,
      },
      {
        label: 'Mevos',
        href: '/admin/mevos',
        id: 'mevos',
        disabled: false,
        Icon: ArrowNarrowRightIcon,
      },
      {
        label: 'Vestigingen',
        href: '/admin/branches',
        id: 'branches',
        disabled: false,
        Icon: OfficeBuildingIcon,
      },
      {
        label: 'Evaluaties',
        href: '/admin/evaluations',
        id: 'evaluations',
        disabled: false,
        Icon: ClipboardListIcon,
      },
    ],
  },
  {
    label: 'Topics',
    tabs: [
      {
        label: 'Topics',
        href: '/admin/topics',
        id: 'topics',
        disabled: false,
        Icon: ChatAltIcon,
      },
    ],
  },
  {
    label: 'Settings',
    tabs: [
      {
        label: 'Subjects',
        href: '/admin/subjects',
        id: 'subjects',
        disabled: false,
        Icon: CloudIcon,
      },
      {
        label: 'Categories',
        href: '/admin/categories',
        id: 'categories',
        disabled: false,
        Icon: HashtagIcon,
      },
    ],
  },
  {
    label: 'E-learning',
    tabs: [
      {
        label: 'Voortgang',
        href: '/admin/progress',
        id: 'progress',
        disabled: false,
        Icon: FastForwardIcon,
      },
      {
        label: 'Feedback',
        href: '/admin/feedback',
        id: 'feedback',
        disabled: false,
        Icon: StarIcon,
      },
    ],
  },
  {
    label: 'Beveiliging',
    tabs: [
      {
        label: 'Cohorten',
        href: '/admin/cohorts',
        id: 'cohorts',
        disabled: false,
        Icon: LockClosedIcon,
      },
      {
        label: 'Auditlog',
        href: '/admin/auditlog',
        id: 'auditlog',
        disabled: false,
        Icon: DocumentTextIcon,
      },
    ],
  },
];

// The admin nav rides above the content as a horizontal bar rather than
// occupying a grid column. Admin screens are dense tables — the width is worth
// far more to them than to a list of short links, and with no side columns
// Main gives the content pane the full grid width.
function Admin() {
  const params = useParams();

  return (
    <Main
      fullBleed
      main={
        <div className="flex flex-col flex-1 px-8 pt-8">
          <Sidebar
            selectedTab={params.tab as string}
            tabGroups={tabItems}
            orientation="horizontal"
          />
          <AdminPanelMainContent />
        </div>
      }
      contentLeft={null}
      contentRight={null}
    />
  );
}

export default Admin;
